export const CARD_READ_WARNING_DAYS = 28

export type CardReadStatus = 'overdue' | 'warning' | 'ok'


export const getCardReadStatus = (
  lastCardReadDate: string | null,
  periodStart: string | null,
): CardReadStatus => {
  if (!lastCardReadDate) return 'overdue'
  if (!periodStart) return 'ok'

  const read = new Date(lastCardReadDate)
  const start = new Date(periodStart)
  if (Number.isNaN(read.getTime()) || Number.isNaN(start.getTime())) return 'ok'

  if (read.getTime() >= start.getTime()) return 'ok'

  const overdueThreshold = new Date(start.getTime())
  overdueThreshold.setDate(overdueThreshold.getDate() - CARD_READ_WARNING_DAYS)
  return read.getTime() < overdueThreshold.getTime() ? 'overdue' : 'warning'
}

export const cardReadStatusClass = (status: CardReadStatus): string => {
  if (status === 'overdue')
    return 'tw-bg-red-50 tw-text-red-700 tw-rounded tw-px-2 tw-py-1'
  if (status === 'warning')
    return 'tw-bg-amber-50 tw-text-amber-700 tw-rounded tw-px-2 tw-py-1'
  return ''
}
